import React from 'react';
import classNames from 'classnames';

export default function TileGroup({ children, className }) {
  return (
    <div className={classNames(
      'grid grid-cols-1 gap-4 sm:grid-cols-2',
      className
    )}>
      {children}
    </div>
  );
}
